<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="four">
<h1>Four</h1>
<p>Bonita stepped onto the dock, and walked over to where the passengers were gathering to collect their luggage and supplies. There were some locals waiting for their cargo as well. The sun was rising on a cloudless day, it was cool from the night but would heat up soon enough.</p>
<p>‘Bonita Apple?’</p>
<p>She turned and recognised the tall blonde woman as one of the crew with Tunn.</p>
<p>‘Christy Fall.’</p>
<p>‘Oh, hi, you know who I am?’ said Bonita.</p>
<p>‘Absolutely, I read your ongoing piece on economics. So did Samson.’</p>
<p>She felt an unconscious flutter in her stomach.</p>
<p>‘You and about three others, I think,’ she said, the irony not lost on Fall.</p>
<p>‘Ha ha, yes, the response was a deafening silence, I guess, but we thought it had merit in areas.’</p>
<p>Her face dropped just a little. She wasn’t good at hiding her feelings.</p>
<p>‘Sorry, I didn’t mean that, just that some of it was extra interesting, we’re watching your guys’ progress with interest.’</p>
<p>‘Well, we’re interested in your approach as well, Christy.’ ‘Right.’</p>
<p>‘You headed to the Bridgewater settlement?’</p>
<p>‘That’s right, we’re joining the aerial division, helping get these things in the air.’</p>
<p>‘It’s incredible what they’re doing now. If only those metals weren’t so expensive.’</p>
<p>Now it was the pilot that frowned.</p>
<p>‘Well, sure, it’ll be a while before everyone has their own flying machine, but in the meantime, we do what we do, and it’s paid for fair and square.’</p>
<p>‘I don’t like that Blackbeard money. Do you really trust him?’</p>
<p>‘No, we’re not stupid. But this is the only way we can get it done right now. There’s a war on. Someone else can worry about patents and all that.’</p>
<p>‘Fair enough. I hear the pay is good.’</p>
<p>‘The pay is great, better than the forces. With the pension as well, we’re all good.’</p>
<p>‘All we need now is children,’ Bonita said with a grin. ‘Fall.’ Tunn was walking towards them.</p>
<p>‘Captain?’</p>
<p>‘We need you on the spider. Ms Apple, how’re you doing?’</p>
<p>The women shook hands as Fall headed back to the edge of the dock.</p>
<p>‘Doing just fine, sir.’</p>
<p>He looked at her for a moment.</p>
<p>‘You probably know, I’m not a huge fan of communists and what they’re doing right now.’</p>
<p>‘Got it. I’m not a fan of China either.’</p>
<p>‘Well, that’s something, I guess. Do you want to catch a ride with us up to the crossroads?’</p>
<p>The spider was coming to life, its legs widening their stance and lifting the carriage oﬀ the ground. It would be an easy trip up the hill with her pack in the back, but the fact was, she didn’t want to be seen with the military types.</p>
<p>‘Thanks, but I need to stretch my legs, get my bearings.’</p>
<p>‘Understood. Nice to meet you, ma’am.’</p>
<p>‘You too, sir.’</p>
<p>There were road signs with directions but she knew her way already.</p><br/>
<p style="text-align: center;">***</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?69a9cbd6